<div class="search-dialog">
  <mat-icon class="close" (click)="onNoClick()">close</mat-icon>
  <h2 mat-dialog-title>{{ dialogTitle }}</h2>
  <mat-dialog-content>
    <mat-error *ngIf="filterNameFormControl.hasError('required')">
      <span class="error_text"
        >Filter Name was not <strong>provided</strong>.</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        filterNameFormControl.hasError('invalidFilterName') &&
        !filterNameFormControl.hasError('required')
      "
    >
      <span class="error_text">Please provide a Unique name.</span>
    </mat-error>
    <mat-form-field floatLabel="never">
      <input
        matInput
        placeholder="Filter Name"
        [formControl]="filterNameFormControl"
        [errorStateMatcher]="filterNameMatcher"
      />
      <mat-hint class="required-field">
        <span
          [ngClass]="{
            error_text:
              filterNameFormControl.hasError('required') ||
              filterNameFormControl.hasError('invalidFilterName')
          }"
          >*Required</span
        >
      </mat-hint>
    </mat-form-field>

    <mat-grid-list cols="1" rowHeight="70px">
      <mat-grid-tile style="text-align: left">
        <mat-form-field
          class="keywords-chip-list w-100"
          floatLabel="never"
          [hidden]="isHomePage === 'true'"
        >
          <input
            matInput
            #keywordChipInputBox
            class="m-0"
            placeholder="Keywords or Phrases"
            [matChipInputFor]="keywordChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addKeyword($event)"
          />
          <mat-icon matSuffix class="icon-search">search</mat-icon>
        </mat-form-field>
        <app-multi-dropbox
          popupPositionLeft="44"
          class="drop-box-item"
          cssClassToApply="dropbox-145"
          appearance="outline"
          [(ngModel)]="markets"
          placeholder="Market(s)"
          (modelChange)="loadFormats(); loadStations()"
          placeholderLabel="Find a market..."
          noEntriesFoundLabel="No market found"
          #marketMulti
        ></app-multi-dropbox>
        <app-multi-dropbox
          popupPositionLeft="44"
          class="drop-box-item"
          cssClassToApply="dropbox-145"
          appearance="outline"
          [(ngModel)]="formats"
          placeholder="Format(s)"
          (modelChange)="loadStations()"
          placeholderLabel="Find a format..."
          noEntriesFoundLabel="No format found"
          #formatMulti
          [hidden]="isHomePage === 'false'"
        ></app-multi-dropbox>
        <app-multi-dropbox
          popupPositionLeft="44"
          class="drop-box-item"
          cssClassToApply="dropbox-145"
          appearance="outline"
          [(ngModel)]="stations"
          placeholder="Station(s)"
          placeholderLabel="Find a station..."
          noEntriesFoundLabel="No station found"
          #stationMulti
          [showStationBadge]="true"
        ></app-multi-dropbox>
      </mat-grid-tile>
    </mat-grid-list>
    <hr />
    <div
      class="chip-body"
      [hidden]="
        !(
          keywords?.length > 0 ||
          markets?.length > 0 ||
          stations?.length > 0 ||
          formats?.length > 0
        )
      "
    >
      <div class="chip-title">Filtered by:</div>
      <div class="chip-content">
        <div class="chip-item">
          <mat-chip-list #keywordChipList [hidden]="isHomePage === 'true'">
            <mat-chip
              color="primary"
              selected
              *ngFor="let keyword of keywords"
              [selectable]="selectable"
              (removed)="removeKeyword(keyword)"
            >
              {{ keyword.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <mat-chip-list>
            <mat-chip
              color="primary"
              selected
              *ngFor="let market of markets"
              [selectable]="selectable"
              (removed)="removeMarket(market)"
            >
              {{ market.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <mat-chip-list>
            <mat-chip
              color="primary"
              selected
              *ngFor="let station of stations"
              [selectable]="selectable"
              (removed)="removeStation(station)"
            >
              {{ station.name }}
              <app-badge-station class="badge-chip" [mergedStation]="station.mergedStation"></app-badge-station>
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <mat-chip-list [hidden]="isHomePage === 'false'">
            <mat-chip
              color="primary"
              selected
              *ngFor="let format of formats"
              [selectable]="selectable"
              (removed)="removeFormat(format)"
            >
              {{ format.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <button mat-button class="float-right" (click)="clear()">
        CLEAR FILTERS
      </button>
    </div>
  </mat-dialog-content>

  <div class="clearFilters" *ngIf="isHomePage === 'true'">
    <button
      mat-button
      mat-flat-button
      color="primary"
      class="float-right"
      (click)="saveStationFilter()"
      [disabled]="disableBtn"
      style="margin-right: 10px"
    >
      {{ saveButtonText }}
    </button>
    <button
      mat-button
      class="float-right"
      (click)="deleteStationFilter()"
      [disabled]="!(filterNameFormControl.valid && isEditMode == true)"
      style="margin-right: 10px"
    >
      {{ deleteButtonText }}
    </button>
  </div>
</div>
